






















import Vue from "vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputCheckbox: iwInputCheckbox,
        iwTooltip: iwTooltip,
    },
    data: function () {
        return {
            pathInStore : "transaction.sale.isSubjectToVat",
            inputName: "is-subject-to-vat",
            specificId: uuidv4() as string
        };
    },
    
    computed: {
        isDisplayed: function(): boolean {
            return this.getTransactionType() == "FOR_SALE";
        },

        isSubjectToVat: {
            get: function(): boolean {
                return !!this.$store.getters["FormModule/getValue"](this.pathInStore);
            },

            set: function(value: boolean) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStore,
                    value: value
                });
            },
        },
    },
    mounted: function() {
        if (this.isDisplayed) {
            if(this.$store.getters["FormModule/getValue"](this.pathInStore) == null) {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: false});
            }
        } else {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
});
